import type { Database } from '@biopeak/db';
import { createClient } from '@supabase/supabase-js';

/**
 * Cliente Supabase do painel do médico.
 *
 * A segurança de verdade está no RLS, não no segredo da chave publicável.
 * O que o RLS garante para este app, especificamente:
 *
 * - `is_my_patient()` restringe toda leitura de dado clínico aos pacientes
 *   vinculados a este médico — outro médico não alcança nada aqui.
 * - `patient_status` não tem policy de UPDATE nem para o médico: o override
 *   manual passa pela RPC `override_patient_status`, que grava status +
 *   histórico + auditoria atomicamente e valida a justificativa.
 * - `alert_rules` e `doctors` (dados próprios) têm INSERT/UPDATE diretos,
 *   mas sempre condicionados a `is_my_patient` / `user_id = auth.uid()`.
 */

const url = import.meta.env.VITE_SUPABASE_URL;
const publishableKey = import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY;

if (!url || !publishableKey) {
  throw new Error(
    'VITE_SUPABASE_URL e VITE_SUPABASE_PUBLISHABLE_KEY sao obrigatorios. Copie .env.example para .env.',
  );
}

export const supabase = createClient<Database>(url, publishableKey, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: false,
  },
});
